// Generated by Claude Code
import { Api } from '#core/api/Api.ts'
import { PriceRates } from '#core/entities/operations/shared/Price.ts'

/** API client for how the company shows prices (`/operations/price-rates`): its display currency and the currency rate history. */
export default class PriceRatesApi extends Api<PriceRatesApi> {
  constructor() {
    super()
  }

  /** Returns the display currency and the rate tables prices are converted with, oldest first. */
  public async getRates(): Promise<PriceRates> {
    return (await this.get<PriceRates>('operations/price-rates', undefined, PriceRates)) ?? new PriceRates()
  }
}
